/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

/**
 * Form for allowing an additional CIMD document URL on a user_session_issuer.
 */
export type CreateUserSessionIssuerCimdClientForm = {
  /**
   * The exact https URL the client presents as its client_id. Matched byte for byte at authorization time — the spec forbids normalization, so this must be the vendor's published URL exactly.
   */
  clientIdMetadataUri: string;
  /**
   * The user_session_issuer the URL is allowed on.
   */
  userSessionIssuerId: string;
};

/** @internal */
export type CreateUserSessionIssuerCimdClientForm$Outbound = {
  client_id_metadata_uri: string;
  user_session_issuer_id: string;
};

/** @internal */
export const CreateUserSessionIssuerCimdClientForm$outboundSchema:
  z.ZodMiniType<
    CreateUserSessionIssuerCimdClientForm$Outbound,
    CreateUserSessionIssuerCimdClientForm
  > = z.pipe(
    z.object({
      clientIdMetadataUri: z.string(),
      userSessionIssuerId: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        clientIdMetadataUri: "client_id_metadata_uri",
        userSessionIssuerId: "user_session_issuer_id",
      });
    }),
  );

export function createUserSessionIssuerCimdClientFormToJSON(
  createUserSessionIssuerCimdClientForm: CreateUserSessionIssuerCimdClientForm,
): string {
  return JSON.stringify(
    CreateUserSessionIssuerCimdClientForm$outboundSchema.parse(
      createUserSessionIssuerCimdClientForm,
    ),
  );
}
